export const brandIconList = [
  'icon-account',
  'icon-alert-circle',
  'icon-arrow-double',
  'icon-arrow-down',
  'icon-arrow-left',
  'icon-arrow-right',
  'icon-arrow-up',
  'icon-brand',
  'icon-brand-xs',
  'icon-brand-xs-circle',
  'icon-burger',
  'icon-calendar',
  'icon-cart',
  'icon-chat',
  'icon-check',
  'icon-check-circle',
  'icon-copy',
  'icon-cross',
  'icon-delete',
  'icon-document',
  'icon-download',
  'icon-edit',
  'icon-heart',
  'icon-heart-filled',
  'icon-help',
  'icon-magnify',
  'icon-mail',
  'icon-minus',
  'icon-phone',
  'icon-play',
  'icon-plus',
  'icon-printer',
  'icon-star',
  'icon-star-filled',
  'icon-star-filled-colored',
  'icon-star-filled-half',
  'icon-switch',
  'icon-target',
  'icon-trash',
  'icon-web',
  'icon-world'
];
